let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("ahxSD"), load("68Kzv"), load("3NvtU"), load("7zMjZ"), load("a1dBM"), load("ehm4l")]).then(() => parcelRequire('jorgl'));